import { FC, memo, useContext } from 'react';
import { ScAuroraPanel } from './styled';

import navDeskSrc from 'assets/images/quest/nav-desk.webp';
import { useTheme } from 'hooks/theme';
import { useNavigation } from 'react-navi';
import { EMissionMode, useQuestPromo } from 'modules/quest/hooks';

import missionContainerSrc from '../../../../../assets/images/quest/mission-container.webp';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '@repo-level/core-front';

export interface IQuestPanelProps {
  onLinkClick?: () => void;
}

export const QuestPanel: FC<IQuestPanelProps> = memo(({ onLinkClick }) => {
  const { t } = useTranslation('quest');

  const { isAuthenticated } = useContext(AuthContext);

  const { images } = useTheme();

  const { navigate } = useNavigation();

  const { currentMission } = useQuestPromo();

  if (!currentMission) return null;
  const { foregroundSrc, completeImg, mode } = currentMission;

  const dashboardKey =
    mode === EMissionMode.AVAILABLE ? 'activeMission' : 'completeMission';

  return (
    <ScAuroraPanel
      onClick={() => {
        onLinkClick && onLinkClick();
        navigate('/quest');
      }}
    >
      <img className="bg" src={navDeskSrc} alt="background" />
      <div className="inner">
        <div className="content">
          <div className="content-text">
            <Display
              className="mobile"
              completeImg={completeImg}
              foregroundSrc={foregroundSrc}
            />
            <div className="title">
              <Display
                className="desktop"
                completeImg={completeImg}
                foregroundSrc={foregroundSrc}
              />

              <p>Elf's Gift Machine</p>
            </div>
          </div>
          {isAuthenticated && (
            <p className="message-2 desktop">
              {t(`dashboard.${dashboardKey}`)}
            </p>
          )}
        </div>
        <div className="mobile">
          <images.arrowRightSmallIcon.component />
        </div>
      </div>
    </ScAuroraPanel>
  );
});

interface IDisplayProsp {
  className: string;
  completeImg: string | undefined;
  foregroundSrc: string | undefined;
}

const Display: FC<IDisplayProsp> = ({
  className,
  completeImg,
  foregroundSrc,
}) => {
  return (
    <div className={`display ${className}`}>
      <img src={missionContainerSrc} className="background" alt="mission bg" />
      {completeImg && (
        <img src={completeImg} className="prize" alt="mission inactive" />
      )}
      {foregroundSrc && (
        <img className="foreground" src={foregroundSrc} alt="diamond" />
      )}
    </div>
  );
};
